import { useEffect, useState } from "react";
import { Clock } from "lucide-react";

function rel(ts) {
  const s = Math.max(0, Math.floor(Date.now() / 1000 - ts));
  if (s < 60) return "just now";
  const m = Math.floor(s / 60);
  if (m < 60) return `${m} min ago`;
  const h = Math.floor(m / 60);
  if (h < 24) return `${h} hr${h > 1 ? "s" : ""} ago`;
  const d = Math.floor(h / 24);
  return `${d} day${d > 1 ? "s" : ""} ago`;
}

// Tiny trust line under AI cards: "as of <time> · grounded on N live headlines".
export function FreshnessLine({ generatedAt, headlineCount = 0, className = "" }) {
  const [, setTick] = useState(0);
  useEffect(() => {
    const id = setInterval(() => setTick((n) => n + 1), 30000);
    return () => clearInterval(id);
  }, []);
  if (!generatedAt) return null;
  return (
    <div
      className={`flex items-center gap-1.5 text-[10px] uppercase tracking-widest text-zinc-600 ${className}`}
      data-testid="ai-freshness"
    >
      <Clock size={10} strokeWidth={1.5} className="shrink-0" />
      <span>As of {rel(generatedAt)}</span>
      {headlineCount > 0 && (
        <span>· grounded on {headlineCount} live headline{headlineCount > 1 ? "s" : ""}</span>
      )}
    </div>
  );
}
